export default __webpack_public_path__ + "static/AccessControl-6c487df3af6fab15914e64d2e6e0375d.jpg";